<template>
  <div class="h100">
    <div class="row py-5">
      <div class="col-md-2 col-1"></div>
      <div class="col-md-8 col-10">
        <div class="w-100 p-5 m-2 text-center" dir="rtl">
          <h4>سایت در حال بروز رسانی میباشد لطفا بعدا مراجعه فرمایید!</h4>
          <div class="bg-warning font-weight-bold w-100" style="height: 3px !important" />
          <img src="../../../public/Image/wrenchBlack.png" class="mt-5" style="height: 50vh !important" alt="" />
        </div>
      </div>
      <div class="col-md-2 col-1"></div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
}
</script>
<style scoped>
.h100 {
  height: 100vh !important  ;
  background: #fff;
}
.Border-radius {
  border-radius: 15px;
  min-height: 50vh !important ;
}
</style>
